import React from "react";
// import { StaticImage } from "gatsby-plugin-image";
import FigureCover from "../FigureCover";
import template3Graphique from "../../images/template3-graphique.svg";

const gridStyle = {
  display: "grid",
  // gridGap: "5px",
  gridTemplateRows: "27.6% 57.6% 14.8%",
  gridTemplateAreas: `
    'header'
    'center'
    'footer'
  `
  // gridAutoRows: "0;"
};

const PC3 = ({ input }) => {
  console.log(input);
  // return null;
  return (
    <div className='template3'>
      <div className='grid h-screen' style={gridStyle}>
        <div className='group' style={{ gridArea: "header" }}>
          <div className='flex h-full'>
            <div className='image1 h-full' style={{ maxWidth: "32%" }}>
              <FigureCover input={input[0]} />
            </div>
            <div className='image1 h-full'>
              <FigureCover input={input[1]} />
            </div>
          </div>
        </div>

        <div className='group' style={{ gridArea: "center" }}>
          <div className='absolute w-full z-10'>
            {/* <StaticImage
            src={"../../images/template3-graphique.svg"}
            alt='template3 graphique'
            className='w-full h-full'
            placeholder='blurred'
          /> */}
            <img
              src={template3Graphique}
              alt='template3Graphique'
              className='w-full'
            />
          </div>
          <FigureCover input={input[2]} />
          <div className='absolute w-full z-10 bottom-0'>
            {/* <StaticImage
            src={"../../images/template3-graphique.svg"}
            alt='template3 graphique'
            className='w-full h-full'
            placeholder='blurred'
          /> */}
            <img
              src={template3Graphique}
              alt='template3Graphique'
              className='w-full'
            />
          </div>
        </div>

        <div className='group' style={{ gridArea: "footer" }}>
          <div className='flex h-full'>
            <div style={{ maxWidth: "17.744360902%" }}>
              <FigureCover input={input[3]} />
            </div>

            <FigureCover input={input[4]} />
            <FigureCover input={input[5]} />
            <div style={{ maxWidth: "17.744360902%" }}>
              <FigureCover input={input[6]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PC3;
